<template>
	<app-page>
		<app-heading title="Features" />
		<app-row>
			<app-cell>
				<app-data-table
					:items="features"
					:total="count"
					:headers="headers"
					@update="fetchFeatures"
				/>
			</app-cell>
		</app-row>
	</app-page>
</template>

<script>
export default {
	data() {
		return {
			features: [],
			count: -1,
			headers: [{
				text: 'ID',
				value: 'studeo_id',
				sortable: true,
			}, {
				text: 'Name',
				value: 'name',
				sortable: false,
			}, {
				text: 'Category',
				value: 'category.name',
				sortable: false,
			}, {
				text: 'Always included?',
				value: 'always_included',
				sortable: false,
			}],
		}
	},
	methods: {
		async fetchFeatures(pagination) {
			const request = this.$ravello.graphql('features')
				.fields(['_id', 'name', 'studeo_id', 'always_included'])
				.include(this.$ravello.graphql('category').field('name'))
				.fromPagination(pagination)

			if (this.count === -1) {
				request.count('count')
			}

			try {
				this.features = await request.query()
				if (this.count === -1) {
					this.count = request.results.count
				}
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
		},
	},
}
</script>
